import Base from "./base.service";

export default class Timekeeping extends Base {
  constructor() {
    super("time-keeping");
  }
}
